import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { sendersIsLoadingSelector } from '../common/selectors/senders-selectors';
import { mySenderProfileDataSelector } from './selectors/sender-details-selectors';
import SenderDetailsTabProfile from './sender-details-tab-profile';
import LoadingSectionWrapper from '../common/components/loading-section-wrapper';

export const SenderDetailsTabProfileContainer = ( { isLoading, senderProfileData } ) => {
    const LoadingSection = LoadingSectionWrapper( SenderDetailsTabProfile );

    return (
        <LoadingSection isLoading={isLoading} senderData={senderProfileData}/>
    );
};

/* istanbul ignore next */
const mapStateToProps = state => {
    return {
        isLoading: sendersIsLoadingSelector( state ),
        senderProfileData: mySenderProfileDataSelector( state ),
    };
};

SenderDetailsTabProfileContainer.propTypes = {
    isLoading: PropTypes.bool.isRequired,
    senderProfileData: PropTypes.object,
};

SenderDetailsTabProfileContainer.defaultProps = {
    senderProfileData: {},
};

export default connect( mapStateToProps )( SenderDetailsTabProfileContainer );
